// import constants from '@playcastdotio/GlobalConfig';
import { Button } from '@playcastdotio/Shadcn';

export const About = () => {
  return (
    <div>
      <h1 className='text-primary text-3xl font-[Syne] font-bold'>About the Beta</h1>
      <div className='flex flex-col space-y-6 mt-4'>
        <div>
          Welcome to the Playcast Beta release program. Our highly dedicated team of engineers have been hard at work for the past two years
          to bring this amazing technology into existence.
        </div>
        <div>
          We would like your feedback. The best way to do this is through{' '}
          <a href='https://discord.gg/84tFfvuaus'>
            <Button variant='link' className='p-0 h-0'>
              our Discord server
            </Button>
          </a>
          . We will also provide more information on our website at{' '}
          <a href='https://playcast.io'>
            <Button variant='link' className='p-0 h-0'>
              playcast.io
            </Button>
          </a>
        </div>
        <div>
          Again, thank you for participating, send us your feedback, share it with your friends, and best of all, find all the new and
          exciting ways to use Playcast for a better online experience.
        </div>
      </div>
      {/* <p>Version: {constants.VERSION}</p>
      {constants.ENVIRONMENT === 'development' && <p>Development mode</p>}
      {constants.ENVIRONMENT === 'preview' && <p>Preview mode</p>} */}
    </div>
  );
};

